exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-5e2b3feb] {\n  text-decoration: underline;\n}\n", ""]);

// exports
